import React, { useRef, useState } from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md';
import {RiMessengerLine} from 'react-icons/ri';
import {BsWhatsapp} from 'react-icons/bs';
import emailjs from '@emailjs/browser';
// import { EMAILJS_CONFIG } from './EmailJSConfig';
import { toast } from 'react-toastify'

const Contact = () => {

  const form = useRef();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    title: 'test',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);


  const EMAILJS_CONFIG = {
    SERVICE_ID: 'service_o4hep2v',      // From Email Services
    TEMPLATE_ID: 'template_roo0py8',    // From Email Templates
    PUBLIC_KEY: 'K7lzitdCeGri96T0h'         // From Account → API Keys
};
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    emailjs
        .send(EMAILJS_CONFIG.SERVICE_ID, EMAILJS_CONFIG.TEMPLATE_ID, formData, EMAILJS_CONFIG.PUBLIC_KEY)
        .then(
            (result) => {
              console.log('SUCCESS!', result.text);
              setTimeout(() => {
                toast.success("Message sent! Thanks — I’ll get back to you soon.")
              }, 1000);

            },
            (error) => {
              setTimeout(() => {
                toast.error("Message failed to send. Please try again.")

              }, 1000);


            }
        )
        .finally(() => {
          setIsSubmitting(false);
          setFormData({ name: '', email: '', title: '', message: '' });

        });


    // Simulate form submission
  };


const data = [
  {
    id:1,
    message: "Send a message",
    mail:"chathuraprabashwara@gmail.com",
    link:"mailto:chathuraprabashwara@gmail.com",
    icon:<MdOutlineEmail className='contact__option-icon' />,
    header:"Email"
    
  },
  {
    id:2,
    message: "Send a messag",
    mail:"Chathura Prabashwara",
    link:"https://m.me/chathuraprabashwara123/",
    icon:<RiMessengerLine className='contact__option-icon'/>,
    header:"Messanger"
    
  },
  {
    id:3,
    message: "Send a messag",
    mail:"+94710182989",
    link:"https://api.whatsapp.com/send?phone=94710182989",
    icon:<BsWhatsapp className='contact__option-icon'/>,
    header:"Whatsapp"
    
  }
]

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Conatact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
     { data.map((data)=>  <article className="contact__option">
          {data.icon}
          <h4>{data.header}</h4>
          <h5>{data.mail}</h5>
          <a href={data.link} target="_blank" rel="noreferrer">{data.message}</a>
        </article>)}
        </div>
        {/* End of contact options */}
        <form ref={form}  onSubmit={handleSubmit}>
          <input type="text" onChange={handleChange} value={formData.name} name='name' placeholder='Your Full name' required />
          <input type="email" onChange={handleChange} value={formData.email} name='email' placeholder='Your Email' required />
          <textarea name="message" onChange={handleChange} value={formData.message} rows="7" placeholder='Your Message' required ></textarea>
          <button type='submit' className='btn btn-primary '>                  {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>

        </form>
      </div>
    </section >
  )
}

export default Contact